var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:twitter-x-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2083 2.91675H2L14.0458 18.9788L2.65625 32.0834H6.52083L15.8367 21.3661L23.875 32.0834H34.0833L21.53 15.3447L32.3333 2.91675H28.4687L19.7392 12.9588L12.2083 2.91675ZM25.3333 29.1667L7.83333 5.83341H10.75L28.25 29.1667H25.3333Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterX);
export default __webpack_public_path__ + "static/media/twitterX.1a06c2b4edbbada76af52a0e3e81c661.svg";
export { ForwardRef as ReactComponent };